import type { Routes } from '@angular/router';
import { BatchListComponent } from '../components/batch-list/batch-list.component';

export const batchRoutes: Routes = [
  {
    path: 'batches',
    children: [
      {
        path: '',
        component: BatchListComponent
      },
      {
        path: 'verify/:batchId',
        loadComponent: () => import('../components/verify/verify.component')
          .then(m => m.VerifyComponent)
      },
      {
        path: 'verify/:batchId/page/:pageId',
        loadComponent: () => import('../components/verify/verify.component')
          .then(m => m.VerifyComponent)
      },
      {
        path: 'hk-trade',
        loadComponent: () => import('../components/batch-screens/hk-trade-batch/hk-trade-batch.component')
          .then(m => m.HkTradeBatchComponent)
      },
      {
        path: 'agency-desk',
        loadComponent: () => import('../components/batch-screens/agency-desk-batch/agency-desk-batch.component')
          .then(m => m.AgencyDeskBatchComponent)
      },
      {
        path: 'gnm',
        loadComponent: () => import('../components/batch-screens/gnm-batch/gnm-batch.component')
          .then(m => m.GnmBatchComponent)
      },
      {
        path: 'vcf',
        loadComponent: () => import('../components/batch-screens/vcf-batch/vcf-batch.component')
          .then(m => m.VCFBatchComponent)
      },
      {
        path: 'fees',
        loadComponent: () => import('../components/batch-screens/fees-batch/fees-batch.component')
          .then(m => m.FeesBatchComponent)
      },
      {
        path: 'hk-lc',
        loadComponent: () => import('../components/batch-screens/hk-lc-batch/hk-lc-batch.component')
          .then(m => m.HkLcBatchComponent)
      }
      ,
      {
        path: 'pf-eu',
        loadComponent: () => import('../components/batch-screens/project-finance/pf-eu-batch.component')
          .then(m => m.PfEuBatchComponent)
      },
      {
        path: 'pf-na',
        loadComponent: () => import('../components/batch-screens/project-finance/pf-na-batch.component')
          .then(m => m.PfNaBatchComponent)
      }
    ]
  }
];